import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
  Modal,
} from "react-bootstrap";

import axios from "axios";
import PageLayout from "../../../layouts/PageLayout";
import Swal from 'sweetalert2'
import { useParams, useNavigate } from "react-router-dom";
export default function EditTraining() {
  const [families, setFamilies] = useState([]);
  const [children, setChildren] = useState([]);
  const [cities, setCities] = useState([]);
  const [donors, setDonors] = useState([]);
  const [institutes, setInstitutes] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [trainingId, setTrainingId] = useState(1);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [videoUploading, setVideoUploading] = useState(false);
  const [showInstituteModal, setShowInstituteModal] = useState(false);
  const [showTrainingModal, setShowTrainingModal] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [formErrors, setFormErrors] = useState({});

  const [form, setForm] = useState({
    person_id: "",
    children_id: "",
    student_name: "",
    relation: "",
    donor_id: "",
    institute_id: "",
    course_id: "",
    duration: "",
    fee: "",
    progress: "",
    story: "",
    start_date: "",
    end_date: "",
    before_image: null,
    after_image: null,
    fee_receipt: null,
  });

  const [previews, setPreviews] = useState({
    before_image: null,
    after_image: null,
  });

  const [newInstitute, setNewInstitute] = useState({
    name: "",
    city_id: "",
    address: "",
    contact_number: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();
  const [newTraining, setNewTraining] = useState("");

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  useEffect(() => {
    fetchInitialData();
    fetchTraining();
  }, []);
  const fetchTraining = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/vocational-training/${id}`
      );

      const training = res.data.data;

      setForm({
        person_id: training.person_id || "",
        children_id: training.children_id || "",
        student_name: training.student_name || "",
        relation: training.relation || "",
        donor_id: training.donor_id || "",
        institute_id: training.institute_id || "",
        course_id: training.course_id || "",
        duration: training.duration || "",
        fee: training.fee || "",
        progress: training.progress || "",
        story: training.story || "",
        start_date: training.start_date || "",
        end_date: training.end_date || "",
        before_image: null,
        after_image: null,
        fee_receipt: training.fee_receipt || null,
      });

      setTrainingId(training.id);

      if (training.person_id) {
        const childRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/initial-trainings-data/${training.person_id}`
        );

        setChildren(childRes.data.family || []);
      }

      setPreviews({
        before_image: process.env.REACT_APP_IMG_URL + training.before_image || null,
        after_image: process.env.REACT_APP_IMG_URL + training.after_image || null,
      });
    } catch (error) {
      console.error(error);
    }
  };
  const fetchInitialData = async () => {
    const res = await axios.get(
      process.env.REACT_APP_API_URL + "/initial-trainings-data"
    );

    setFamilies(res.data.data || []);
    setDonors(res.data.donors || []);
    setInstitutes(res.data.institutes || []);
    setTrainings(res.data.courses || []);
    setCities(res.data.cities || []);
  };

  const handleFamilyChange = async (e) => {
    const familyId = e.target.value;

    setForm((prev) => ({
      ...prev,
      person_id: familyId,
      children_id: "",
      student_name: "",
      relation: "",
    }));

    const res = await axios.get(
      process.env.REACT_APP_API_URL +
      `/initial-trainings-data/${familyId}`
    );

    setChildren(res.data.family || []);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleChildChange = (e) => {
    const name = e.target.value;
    const selected = children.find((c) => c.name === name);
    console.log("Selected Child:", name, selected);
    setForm({
      ...form,

      student_name: selected?.name || "",
      relation: selected?.relation || "",
    });
  };

  const handleImageChange = (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

    if (previews[field]) URL.revokeObjectURL(previews[field]);

    const url = URL.createObjectURL(file);

    setForm((prev) => ({ ...prev, [field]: file }));
    setPreviews((prev) => ({ ...prev, [field]: url }));
  };

  const removeImage = (field) => {
    if (previews[field]) URL.revokeObjectURL(previews[field]);

    setForm((prev) => ({ ...prev, [field]: null }));
    setPreviews((prev) => ({ ...prev, [field]: null }));

    const input = document.getElementById(`input-${field}`);
    if (input) input.value = "";
  };

  const validate = () => {
    const errors = {};

    if (!form.person_id) errors.person_id = "Family is required";
    if (!form.student_name) errors.student_name = "Student is required";
    if (!form.institute_id) errors.institute_id = "Institute is required";
    if (!form.course_id) errors.course_id = "Training is required";
    if (!form.duration) errors.duration = "Duration is required";
    if (form.fee === "") errors.fee = "Fee is required";
    if (!form.progress) errors.progress = "Status is required";
    if (!form.story) errors.story = "Story is required";
    if (!form.start_date) errors.start_date = "Start Date is required";

    if (Number(form.fee) > 0 && !form.fee_receipt) {
      errors.fee_receipt = "fee_receipt is required when fee is greater than 0";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!validate()) {
      Swal.fire({
        title: "Error!",
        text: "Please fix the errors in the form.",
        icon: "error",
      });
      return;
    }

    try {
      const data = new FormData();

      Object.keys(form).forEach((key) => {
        if (form[key] !== null && form[key] !== "") {
          data.append(key, form[key]);
        }
      });

      await axios.post(
        `${process.env.REACT_APP_API_URL}/vocational-trainings/${id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.fire({
        title: "Success!",
        text: "Training updated successfully.",
        icon: "success",
      });

      navigate("/all-vocational-training");
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error!",
        text: "Failed to update training.",
        icon: "error",
      });
    }
  };
  const saveInstitute = async () => {
    const res = await axios.post(
      process.env.REACT_APP_API_URL + "/store-vocational-institutes",
      newInstitute
    );

    const created = res.data.data;

    setInstitutes((prev) => [...prev, created]);
    setForm((prev) => ({ ...prev, institute_id: created.id }));

    setNewInstitute({
      name: "",
      city_id: "",
      address: "",
      contact_number: "",
    });

    setShowInstituteModal(false);
  };

  const saveTraining = async () => {
    const res = await axios.post(
      process.env.REACT_APP_API_URL + "/store-vocational-courses",
      { course_name: newTraining }
    );

    const created = res.data.data;

    setTrainings((prev) => [...prev, created]);
    setForm((prev) => ({ ...prev, course_id: created.id }));

    setNewTraining("");
    setShowTrainingModal(false);
  };
  const CHUNK_SIZE = 5 * 1024 * 1024; // 2MB

  const uploadVideoInChunks = async () => {

    if (!selectedVideo || !trainingId) {
      Swal.fire({
        title: 'Error!',
        text: 'Please select video and training.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
      return;
    }

    setVideoUploading(true);

    try {
      const totalChunks = Math.ceil(
        selectedVideo.size / CHUNK_SIZE
      );

      for (
        let chunkIndex = 0;
        chunkIndex < totalChunks;
        chunkIndex++
      ) {

        const start = chunkIndex * CHUNK_SIZE;

        const end = Math.min(
          selectedVideo.size,
          start + CHUNK_SIZE
        );

        const chunk = selectedVideo.slice(
          start,
          end
        );

        const fd = new FormData();

        fd.append(
          "training_id",
          String(trainingId)
        );

        fd.append(
          "chunk_index",
          String(chunkIndex)
        );

        fd.append(
          "total_chunks",
          String(totalChunks)
        );

        fd.append(
          "file_name",
          selectedVideo.name
        );

        fd.append(
          "video_chunk",
          chunk,
          `${chunkIndex}_${selectedVideo.name}`
        );

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/vocational-training-video-upload`,
          fd,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log(
          "Upload Response:",
          response.data
        );

        setUploadProgress(
          Math.round(
            ((chunkIndex + 1) /
              totalChunks) *
            100
          )
        );

        // 1 second delay after every chunk
        await new Promise((resolve) =>
          setTimeout(resolve, 1000)
        );
      }

      Swal.fire({
        title: 'Success!',
        text: 'Video uploaded successfully!',
        icon: 'success',
        confirmButtonText: 'Ok'
      });
      window.location.reload();
    } catch (error) {

      console.error(error);

      Swal.fire({
        title: 'Error!',
        text: 'Video upload failed.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });

    } finally {
      setVideoUploading(false);
    }
  };
  return (
    <PageLayout>
      <Card>
        <Card.Body>
          <h4>Edit Vocational Training</h4>
          {
            trainingId && (
              <Form onSubmit={submitForm}>
                <Row>

                  {/* Family */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Family</Form.Label>
                      <Form.Select
                        value={form.person_id}
                        onChange={handleFamilyChange}
                        isInvalid={!!formErrors.person_id}
                      >
                        <option value="">Select</option>
                        {families.map((f) => (
                          <option key={f.id} value={f.id}>
                            {f.f_number}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.person_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* Student */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Student</Form.Label>
                      <Form.Select
                        value={form.student_name}
                        onChange={handleChildChange}
                        isInvalid={!!formErrors.student_name}
                      >
                        <option value="">Select</option>
                        {children.map((c) => (
                          <option key={c.id} value={c.name}>
                            {c.name} ({c.relation})
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.student_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* Donor */}
                  {/* <Col md={6}>
                <Form.Group>
                  <Form.Label>Donor</Form.Label>
                  <Form.Select
                    name="donor_id"
                    value={form.donor_id}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {donors.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col> */}

                  {/* Institute */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Institute</Form.Label>
                      <Form.Select
                        name="institute_id"
                        value={form.institute_id}
                        onChange={(e) =>
                          e.target.value === "__add_new__"
                            ? setShowInstituteModal(true)
                            : handleChange(e)
                        }
                        isInvalid={!!formErrors.institute_id}
                      >
                        <option value="">Select</option>
                        {institutes.map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.name}
                          </option>
                        ))}
                        <option value="__add_new__">+ Add New</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.institute_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* Training */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Training</Form.Label>
                      <Form.Select
                        name="course_id"
                        value={form.course_id}
                        onChange={(e) =>
                          e.target.value === "__add_new__"
                            ? setShowTrainingModal(true)
                            : handleChange(e)
                        }
                        isInvalid={!!formErrors.course_id}
                      >
                        <option value="">Select</option>
                        {trainings.map((t) => (
                          <option key={t.id} value={t.id}>
                            {t.course_name}
                          </option>
                        ))}
                        <option value="__add_new__">+ Add New</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.course_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Duration</Form.Label>
                      <Form.Control
                        type="text"
                        name="duration"
                        value={form.duration}
                        onChange={handleChange}
                        placeholder="Enter Duration"
                        isInvalid={!!formErrors.duration}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.duration}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="progress"
                        value={form.progress}
                        onChange={handleChange}
                        isInvalid={!!formErrors.progress}
                      >
                        <option value="">Select</option>
                        <option value="Enrolled">Enrolled</option>
                        <option value="progress">progress</option>
                        <option value="Dropped">Dropped</option>
                        <option value="On Hold">On Hold</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.course_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Start Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="start_date"
                        value={form.start_date}
                        onChange={handleChange}
                        isInvalid={!!formErrors.start_date}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.start_date}
                      </Form.Control.Feedback>
                    </Form.Group>

                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>End Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="end_date"
                        value={form.end_date}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  {/* Fee */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Fee</Form.Label>
                      <Form.Control
                        type="text"
                        name="fee"
                        value={form.fee}
                        onChange={handleChange}
                        placeholder="Enter fee"
                        isInvalid={!!formErrors.fee}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.fee}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* fee_receipt */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        Fee Receipt{" "}
                        {Number(form.fee) > 0 && !form.fee_receipt && (
                          <span className="text-danger">*</span>
                        )}
                      </Form.Label>
                      <Form.Control
                        type="file"
                        id="input-fee_receipt"
                          accept="image/*"

                        onChange={(e) =>
                          setForm({ ...form, fee_receipt: e.target.files[0] })
                        }
                        isInvalid={!!formErrors.fee_receipt}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.fee_receipt}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* Status */}

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>Before Image</Form.Label>

                      <Form.Control
                        id="input-before_image"
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleImageChange(
                            e,
                            "before_image"
                          )
                        }
                      />

                      {previews.before_image && (
                        <Card className="mt-3">
                          <Card.Body className="text-center">
                            <img
                              src={previews.before_image}
                              alt="Before Preview"
                              style={{
                                width: "100%",
                                maxHeight: "250px",
                                objectFit: "cover",
                                borderRadius: "10px",
                              }}
                            />

                            <Button
                              variant="danger"
                              size="sm"
                              className="mt-2"
                              onClick={() =>
                                removeImage(
                                  "before_image"
                                )
                              }
                            >
                              Remove
                            </Button>
                          </Card.Body>
                        </Card>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>After Image</Form.Label>

                      <Form.Control
                        id="input-after_image"
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleImageChange(
                            e,
                            "after_image"
                          )
                        }
                      />

                      {previews.after_image && (
                        <Card className="mt-3">
                          <Card.Body className="text-center">
                            <img
                              src={previews.after_image}
                              alt="After Preview"
                              style={{
                                width: "100%",
                                maxHeight: "250px",
                                objectFit: "cover",
                                borderRadius: "10px",
                              }}
                            />

                            <Button
                              variant="danger"
                              size="sm"
                              className="mt-2"
                              onClick={() =>
                                removeImage(
                                  "after_image"
                                )
                              }
                            >
                              Remove
                            </Button>
                          </Card.Body>
                        </Card>
                      )}
                    </Form.Group>
                  </Col>
                  {/* Story */}
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Story</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="story"
                        value={form.story}
                        onChange={handleChange}
                        isInvalid={!!formErrors.story}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.story}
                      </Form.Control.Feedback>

                    </Form.Group>
                  </Col>

                </Row>

                <Button type="submit" className="mt-3">
                  Update Training
                </Button>
              </Form>
            )
          }
        </Card.Body>
      </Card>
      {
        trainingId && (
          <Card className="mt-4">
            <Card.Body>
              <h5>Upload Training Video To Update</h5>

              <Form.Control
                type="file"
                accept="video/*"
                onChange={(e) =>
                  setSelectedVideo(
                    e.target.files[0]
                  )
                }
              />

              {uploadProgress > 0 && (
                <div className="progress mt-3">
                  <div
                    className="progress-bar"
                    style={{
                      width: `${uploadProgress}%`,
                    }}
                  >
                    {uploadProgress}%
                  </div>
                </div>
              )}

              <Button
                className="mt-3"
                disabled={
                  !selectedVideo ||
                  videoUploading
                }
                onClick={
                  uploadVideoInChunks
                }
              >
                {videoUploading
                  ? "Uploading..."
                  : "Upload Video"}
              </Button>
            </Card.Body>
          </Card>
        )
      }
      {/* Institute Modal */}
      <Modal show={showInstituteModal} onHide={() => setShowInstituteModal(false)} centered>
        <Modal.Header closeButton className="m-3">
          <Modal.Title>Institute</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-3">
          <Form.Control
            className="mb-2"
            placeholder="Institute Name"
            value={newInstitute.name}
            onChange={(e) =>
              setNewInstitute({
                ...newInstitute,
                name: e.target.value,
              })
            }
          />

          <Form.Select
            className="mb-2"
            value={newInstitute.city_id}
            onChange={(e) =>
              setNewInstitute({
                ...newInstitute,
                city_id: e.target.value,
              })
            }
          >
            <option value="">
              Select City
            </option>

            {cities.map((c) => (
              <option
                key={c.id}
                value={c.id}
              >
                {c.name}
              </option>
            ))}
          </Form.Select>

          <Form.Control
            className="mb-2"
            placeholder="Address"
            value={newInstitute.address}
            onChange={(e) =>
              setNewInstitute({
                ...newInstitute,
                address: e.target.value,
              })
            }
          />

          <Form.Control
            placeholder="Contact Number"
            value={
              newInstitute.contact_number
            }
            onChange={(e) =>
              setNewInstitute({
                ...newInstitute,
                contact_number:
                  e.target.value,
              })
            }
          />
        </Modal.Body>

        <Modal.Footer className="m-3">
          <Button onClick={() => setShowInstituteModal(false)}>Close</Button>
          <Button onClick={saveInstitute}>Save</Button>
        </Modal.Footer>
      </Modal>

      {/* Training Modal */}
      <Modal show={showTrainingModal} onHide={() => setShowTrainingModal(false)} centered>
        <Modal.Header closeButton className="m-3">
          <Modal.Title>Training</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-3">
          <Form.Control
            value={newTraining}
            onChange={(e) => setNewTraining(e.target.value)}
            placeholder="Training name"
          />
        </Modal.Body>
        <Modal.Footer className="m-3">
          <Button onClick={() => setShowTrainingModal(false)}>Close</Button>
          <Button onClick={saveTraining}>Save</Button>
        </Modal.Footer>
      </Modal>
    </PageLayout >
  );
}